import AbstractRequestTask from "../AbstractRequestTask";
import device from "../../../devices/device";
import Launcher from '../../apa/Launcher';
import store from "../../../store";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class ActivateControlPinTask extends AbstractRequestTask {
  constructor(params = {}, version = 'v1') {
    super();
    this.ownParams = params;
    this.version = version;
  }

  getParams() {
    const params = super.getParams();
    const user = store.getState().user;
    const user_id = user.user_id || "";
    delete params.api_version;
    delete params.HKS;
    return Object.assign({}, params, { user_id, ...this.ownParams });

  }

  getUrl() {
    const protocol = 'https';
    const server = Launcher.get("akamai_mfwk");
    const endpoint = 'services/user';
    const version = this.version;
    const apiname = 'activatecontrolpin';

    return `${protocol}://${server}/${endpoint}/${version}/${apiname}`;
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}

}

export default ActivateControlPinTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/ActivateControlPinTask.js